const RO = {
  listedPublicCompany: [
    "societate pe actiuni (SA)"
  ],
  nonProfit: [
    "organizație non-guvernamentală (ONG)"
  ],
  privateCompany: [
    "societate cu raspundere limitata (SRL)"
  ]
};
export {
  RO as default
};
